import './ui-modal.scss';

import axios from 'axios';
import { DOM_TRIGGER_PROP } from '../../core/constants';
riot.tag2('ui-modal', '<yield from="banner"></yield> <div class="ui-modal-container"> <yield from="content"></yield> <div show="{error}"> <yield from="error"></yield> </div> <div show="{loading}"> <yield from="loading"></yield> </div> <a class="ui-modal-close" href="" onclick="{closeHandler}" show="{!opts.disableClose}"><yield from="close"></yield></a> <div class="ui-modal-content"></div> </div>', '', 'class="js-acr-modal {styleClasses + (visible ? \'visible\' : \'\')}" if="{visible && !loading}" onclick="{parentClickHandler}"', function(opts) {

    const self = this;
    const triggers = document.querySelectorAll(`[${DOM_TRIGGER_PROP}]`);

    window.Acr = window.Acr ? window.Acr : {};

    const cache = {};

    self.mixin('bus');

    self.styleClasses = '';

    function openModal(urlParam, content, styleClasses, event) {
      const parameterJoiner = urlParam.indexOf('?') === -1 ? '?' : '&';
      const url = `${urlParam}${parameterJoiner}stub=1`;
      self.visible = true;
      self.styleClasses = styleClasses ? `${styleClasses} ` : '';

      if (url) {
        self.loading = true;

        if (url in cache) {
          self.loading = false;

          self.root.querySelector('.ui-modal-content').innerHTML = cache[url];

          self.update();

          self.bus.trigger(self.bus.EVENTS.MODAL.MODAL_LOADED, {
            url,
            event,
          });
        } else {
          self.error = false;

          axios.get(url)
            .then((result) => {
              self.loading = false;

              cache[url] = result.data;

              self.root.querySelector('.ui-modal-content').innerHTML = result.data;

              self.update();

              self.bus.trigger(self.bus.EVENTS.MODAL.MODAL_LOADED, {
                url,
                event,
              });
            })
            .catch(() => {
              self.loading = false;
              self.error = true;

              self.root.querySelector('.ui-modal-content').innerHTML = '';

              self.update();
            });
        }
      } else if (content) {
        self.loading = false;

        self.root.querySelector('.ui-modal-content').innerHTML = content;

        self.update();

        self.bus.trigger(self.bus.EVENTS.MODAL.MODAL_LOADED, {
          event,
        });
      }
    }

    function openModalHandler(e) {
      e.preventDefault();

      const url = e.target.dataset.uiModalUrl;
      const content = e.target.dataset.uiModalContent;
      const styleClasses = e.target.dataset.uiModalStyleClasses;

      openModal(url, content, styleClasses, e);
    }

    function openModalObserver(data) {
      openModal(data.url, data.content, data.styleClasses, data.event);

      if (window.Acr.TrackingManager) {
        window.Acr.TrackingManager.savePageLoadObject();
      }
    }

    function closeModalObserver() {
      self.visible = false;

      self.update();
    }

    self.closeHandler = () => {
      const closeRaqEvent = Utility.createEvent('closeRaq');

      self.visible = false;
      self.bus.trigger(self.bus.EVENTS.MODAL.MODAL_IS_CLOSING);
      self.bus.trigger(self.bus.EVENTS.ZIPGATE.CLOSE);

      if (window.Acr.TrackingManager) {
        window.Acr.TrackingManager.restorePageLoadObject();
        $(window).trigger('ar.closemodal');
        window.dispatchEvent(closeRaqEvent);
      }
    };

    self.parentClickHandler = (e) => {
      if (e.target.nodeName === 'UI-MODAL') {
        self.closeHandler(e);
        return false;
      }

      return true;
    };

    self.bus.on(self.bus.EVENTS.MODAL.MODAL_OPEN, openModalObserver);
    self.bus.on(self.bus.EVENTS.MODAL.MODAL_CLOSE, closeModalObserver);

    for (let i = 0; i < triggers.length; i++) {
      triggers[i].removeEventListener('click', openModalHandler);
      triggers[i].addEventListener('click', openModalHandler);
    }
});
